module.exports = __webpack_public_path__ + "img/UpWorks.33c6f2f2.webp";